import { render, staticRenderFns } from "./MulAcctPayment.vue?vue&type=template&id=05ffff2d&"
import script from "./MulAcctPayment.vue?vue&type=script&lang=js&"
export * from "./MulAcctPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports